let content_blocks = require('../contents');
let index = [];
let content_entries = [];
let categories = [];

export function init(){
    get_categories_or_entries('categories', function() {});
    get_categories_or_entries('entries', function() {});
    get_categories_or_entries('index', init_table_entries);

    $('#edit_index_modal .btn.delete:not(.init)').on('click', function(){
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        $('#'+block_id).remove();
        content_blocks.show_start_block();
        content_blocks.show_block_order();

        modal.modal('hide');

        modal.find('form')[0].reset();
    }).addClass('init');

    $('#edit_index_modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let modal = $(this);

        modal.find('[name="block_id"]').val(block.attr('id'));
        modal.find('[name="classes"]').val(block.attr('data-class'));
        modal.find('[name="title"]').val(block.attr('data-title'));
        modal.find('[name="count"]').val(block.attr('data-count'));
        modal.find('[name="pagination"]').prop('checked', block.attr('data-pagination') == '1' ? true : false);
        modal.find('[name="link"]').val(block.attr('data-link'));

        let select_view = modal.find('[name="view"]');
        if (block.attr('data-view') != null || block.attr('data-view') != 'undefined') {
            select_view.find('option[value="'+ block.attr('data-view')).prop('selected', true);
        } else {
            select_view.find('option[value="list"]').prop('selected', true);
        }
        select_view.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

        let select_visible = modal.find('[name="visible"]');
        if (block.attr('data-visible') != null || block.attr('data-visible') != 'undefined') {
            select_visible.find('option[value="'+ block.attr('data-visible')).prop('selected', true);
        } else {
            select_visible.find('option[value="visible"]').prop('selected', true);
        }
        
        select_visible.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

        switch (block.attr('data-index-type')) {
            case 'index':
                modal.find('[name="link"]').closest('.x-form-input').removeClass('d-none');
                break;

            case 'categories':
                modal.find('[name="link"]').closest('.x-form-input').addClass('d-none');
                break;

            case 'entries':
                modal.find('[name="link"]').closest('.x-form-input').addClass('d-none');
                break;
        
            default:
                break;
        }

    });

    $('#add_index_modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let modal = $(this);

        show_selects_index(block.attr('data-index-type'));

        modal.find('[name="block_id"]').val(block.attr('id'));

    });

    $('#edit_index').on('submit', function (e) {
        e.preventDefault();
        let block = $('#'+ $(this).find('[name="block_id"]').val());

        block.attr('data-index-type', $(this).find('[name="type"]').val());
        block.attr('data-class', $(this).find('[name="classes"]').val());
        block.attr('data-visible', $(this).find('[name="visible"]').val());
        block.attr('data-view', $(this).find('[name="view"]').val());
        block.attr('data-title', $(this).find('[name="title"]').val());
        block.attr('data-count', $(this).find('[name="count"]').val());
        block.attr('data-pagination', $(this).find('[name="pagination"]').prop('checked') ? 1 : 0);
        block.attr('data-link', $(this).find('[name="link"]').val());
        init_table_entries(block);
        content_blocks.change_visible_button_blocks(block);

        let modal = $(this).closest('.modal');
        modal.modal('hide');
    });

    $('#add_index:not(.init)').on('submit', function (e) {
        e.preventDefault();
        let block = $('#'+ $(this).find('[name="block_id"]').val());
        let type = block.attr('data-index-type');
        let select = $('#add_index .x-form-input:not(.d-none) select');
        let elements = JSON.parse(block.attr('data-elements'));
        if (type != 'index' || elements.length == 0) {
            if(!elements.includes(select.val())){
                elements.push(select.val());
                block.attr('data-elements', JSON.stringify(elements));
        
                init_table_entries(block);
            }
        } else {
            window.messages.warning(__('No es posible añadir mas contenido al bloque'));
        }
        let modal = $(this).closest('.modal');
        modal.modal('hide');
    }).addClass('init');

    $('#content_type').on('change', function() {
        show_selects_index($(this).val());
    });

    $('.block[data-type="index"]').each(function() {
        content_blocks.change_visible_button_blocks($(this));
        // init_entries_actions($(this).find('table'));
    })
}

function show_selects_index(value){
    let selects = $('#add_index select').closest('.x-form-input');
    selects.addClass('d-none');

    let select = $('#add_index #select_' + value).closest('.x-form-input');
    select.removeClass('d-none');
}

export function filter_entries(data) {
    content_entries = $.map(data.results, function(obj, index) {
        return { 
            id: obj.id, 
            text: obj.title,
            slug: obj.slug
        };
    });

    let results = $.map(data.results, function(obj, index) {
        return { 
            id: obj.slug, 
            text: obj.title,
            result: obj.title + '<small class="d-block font-weight-light">' + obj.slug + "</small>"
        };
    });

    return {
        results: results
    };
}

export function filter_index(data) {
    index = $.map(data.results, function(obj, index) {
        return { 
            id: obj.id, 
            text: obj.title,
            slug: obj.slug
        };
    });

    let results = $.map(data.results, function(obj, index) {
        return { 
            id: obj.slug, 
            text: obj.title,
            result: obj.title + '<small class="d-block font-weight-light">' + obj.slug + "</small>"
        };
    });

    return {
        results: results
    };
}

export function filter_categories(data) {
    categories = $.map(data.results, function(obj, index) {
        return { 
            id: obj.id, 
            text: obj.name,
            slug: obj.slug
        };
    });
    
    let results = $.map(data.results, function(obj, index) {
        return { 
            id: obj.slug, 
            text: obj.name,
            result: obj.name + '<small class="d-block font-weight-light">' + obj.slug + "</small>"
        };
    });

    return {
        results: results
    };
}

export function init_table_entries(block) {

    let blocks = block ? block : $('.block[data-type="index"]');
    
    blocks.each(function(){
        let card_body = $(this).find('.card-body');
        let card_empty_body = $(this).find('.card-empty-body');
        if ($(this).attr('data-elements') == '[]') {
            card_body.addClass('d-none');
            card_empty_body.removeClass('d-none');
            card_empty_body.addClass(['d-flex', 'justify-content-center']);
        } else {
            card_body.removeClass('d-none');
            card_empty_body.addClass('d-none');
            card_empty_body.removeClass(['d-flex', 'justify-content-center']);
            let table = $(this).find('table');
            let tbody = $(this).find('tbody');
            let elements = [];

            if ($(this).attr('data-index-type') == 'categories') {
                elements = categories;
            } else if ($(this).attr('data-index-type') == 'entries') {
                elements = content_entries;
            } else {
                elements = index;
            }

            let entries = JSON.parse($(this).attr('data-elements'));
            let rows = '';
            entries.forEach(element => {

                let result = elements.find(({slug}) => slug == element );
                rows += '<tr>'+
                            '<td style="max-width: 20px"><button type="button" class="btn btn-xs btn-danger delete"><i class="fa-solid fa-trash"></i></button></td>'+
                            '<td>' + result.text + '</td>'+
                            '<td class="slug">' + result.slug + '</td>'+
                        '</tr>';
            });
            
            tbody.html(rows);
            init_entries_actions(table);
        }
    });
}

function init_entries_actions(table) {

    table.find('.btn.delete').on('click', function(){
            
        let tr = $(this).closest('tr');
        let block = tr.closest('.block');
        
        let slug = tr.find('.slug').text();
        let elements = JSON.parse(block.attr('data-elements'));
        
        elements = $.grep(elements, function(n) {
            return n != slug;
        });
        
        block.attr('data-elements', JSON.stringify(elements));
        tr.remove();
    });
}

function get_categories_or_entries(index_type, callback) {
    let url = window._routes['microsites.contents.get_entries'].replace('{microsite}', window.microsite_id).replace('{content_type?}', index_type );

    axios.get(url)
        .then((response) => {
            switch (index_type) {
                case 'categories':
                    filter_categories(response.data);
                    callback();
                    break;

                case 'entries':
                    filter_entries(response.data);
                    callback();
                    break;

                case 'index':
                    filter_index(response.data);
                    callback();
                    break;
            
                default:
                    break;
            }
        })
        .catch((error) => {
            console.log('ERROR', error);
        }).finally(() => {
            
        });
}